import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { FilterService } from '@ui/shared/util-filter';
import { toSignal } from '@angular/core/rxjs-interop';
import { FilterContainerModule } from '../../filter-container.module';
import { DropdownFilterComponent } from '../filter-inputs/dropdown-filter/dropdown-filter.component';
import { TextFilterComponent } from '../filter-inputs/text-filter/text-filter.component';
import { map } from 'rxjs';
import { MultiSelectFilterComponent } from '../filter-inputs/multi-select-filter/multi-select-filter.component';

@Component({
    selector: 'ui-filter-mapper',
    imports: [
        FilterContainerModule,
        DropdownFilterComponent,
        TextFilterComponent,
        MultiSelectFilterComponent,
    ],
    templateUrl: './filter-mapper.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterMapperComponent {
    protected readonly _filterDataService = inject(FilterService);

    public searchFilter = toSignal(this._filterDataService.filters$.pipe(
        map(f => f.find(a => a.type === 'search')),
    ), { requireSync: true });

    public filters = toSignal(this._filterDataService.filters$.pipe(
        map(f => f.filter(a => a.type !== 'search')),
    ), { requireSync: true });

    public reloadFilterOptions(): void {
        this._filterDataService.reloadErrored();
    }
}
